import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});

const token = localStorage.getItem('ibn_token');
if (token) api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

export default api;
